import React from 'react';
import { translate } from '../translations';
import { getTheme } from '../Theme';

import { ReactComponent as EmptyIcon } from '../icons/download_empty.svg';
import tempImg from '../images/contact_navImg.png';

const Downloads = () => {
  return (
    <section id="downloads">
      <img className={getTheme('template-img')} src={tempImg} alt={'test'} />
      <div className="container">
          <div className={getTheme('download-container')}>
            <EmptyIcon className={getTheme('downloads-svg')} />
            <h2> {translate('Chwilowo - brak')}</h2>
          </div>
      </div>
    </section>
  );
};

export default Downloads;
